/** Responsive variants keyed by their canonical full-size gallery and indexing URL. */
import image0_480 from "@/assets/hiatal-intro-fundus-en-480.webp.asset.json";
import image0_800 from "@/assets/hiatal-intro-fundus-en-800.webp.asset.json";
import image0_990 from "@/assets/hiatal-intro-fundus-en-990.webp.asset.json";
import image1_480 from "@/assets/hiatal-intro-fundus-es-480.webp.asset.json";
import image1_800 from "@/assets/hiatal-intro-fundus-es-800.webp.asset.json";
import image1_990 from "@/assets/hiatal-intro-fundus-es-990.webp.asset.json";
import image2_480 from "@/assets/hiatal-type-1-repair-en-480.webp.asset.json";
import image2_800 from "@/assets/hiatal-type-1-repair-en-800.webp.asset.json";
import image2_1059 from "@/assets/hiatal-type-1-repair-en-1059.webp.asset.json";
import image3_480 from "@/assets/hiatal-type-1-repair-es-480.webp.asset.json";
import image3_800 from "@/assets/hiatal-type-1-repair-es-800.webp.asset.json";
import image3_1059 from "@/assets/hiatal-type-1-repair-es-1059.webp.asset.json";
import image4_480 from "@/assets/hiatal-type-2-story-preparation-480.webp.asset.json";
import image4_800 from "@/assets/hiatal-type-2-story-preparation-800.webp.asset.json";
import image4_996 from "@/assets/hiatal-type-2-story-preparation-996.webp.asset.json";
import image5_480 from "@/assets/hiatal-type-2-story-preparation-es-480.webp.asset.json";
import image5_800 from "@/assets/hiatal-type-2-story-preparation-es-800.webp.asset.json";
import image5_996 from "@/assets/hiatal-type-2-story-preparation-es-996.webp.asset.json";
import image6_480 from "@/assets/hiatal-type-3-story-hernia-480.webp.asset.json";
import image6_800 from "@/assets/hiatal-type-3-story-hernia-800.webp.asset.json";
import image6_1058 from "@/assets/hiatal-type-3-story-hernia-1058.webp.asset.json";
import image7_480 from "@/assets/hiatal-type-3-story-hernia-es-480.webp.asset.json";
import image7_800 from "@/assets/hiatal-type-3-story-hernia-es-800.webp.asset.json";
import image7_1058 from "@/assets/hiatal-type-3-story-hernia-es-1058.webp.asset.json";
import image8_480 from "@/assets/hiatal-type-iv-upper-gi-en-480.webp.asset.json";
import image8_790 from "@/assets/hiatal-type-iv-upper-gi-en-790.webp.asset.json";
import image9_480 from "@/assets/hiatal-type-iv-upper-gi-es-480.webp.asset.json";
import image9_790 from "@/assets/hiatal-type-iv-upper-gi-es-790.webp.asset.json";
import image10_480 from "@/assets/hiatal-type-iv-patient-before-480.webp.asset.json";
import image10_800 from "@/assets/hiatal-type-iv-patient-before-800.webp.asset.json";
import image10_1200 from "@/assets/hiatal-type-iv-patient-before-1200.webp.asset.json";
import image10_1448 from "@/assets/hiatal-type-iv-patient-before-1448.webp.asset.json";
import image11_480 from "@/assets/hiatal-type-iv-patient-before-es-480.webp.asset.json";
import image11_800 from "@/assets/hiatal-type-iv-patient-before-es-800.webp.asset.json";
import image11_1200 from "@/assets/hiatal-type-iv-patient-before-es-1200.webp.asset.json";
import image11_1448 from "@/assets/hiatal-type-iv-patient-before-es-1448.webp.asset.json";
import image12_480 from "@/assets/scar-tissue-crura-esophagus-en-480.webp.asset.json";
import image12_800 from "@/assets/scar-tissue-crura-esophagus-en-800.webp.asset.json";
import image12_1200 from "@/assets/scar-tissue-crura-esophagus-en-1200.webp.asset.json";
import image12_1456 from "@/assets/scar-tissue-crura-esophagus-en-1456.webp.asset.json";
import image13_480 from "@/assets/scar-tissue-crura-esophagus-es-480.webp.asset.json";
import image13_800 from "@/assets/scar-tissue-crura-esophagus-es-800.webp.asset.json";
import image13_1200 from "@/assets/scar-tissue-crura-esophagus-es-1200.webp.asset.json";
import image13_1456 from "@/assets/scar-tissue-crura-esophagus-es-1456.webp.asset.json";
import image14_480 from "@/assets/hiatal-recurrent-redo-2-480.webp.asset.json";
import image14_800 from "@/assets/hiatal-recurrent-redo-2-800.webp.asset.json";
import image14_1200 from "@/assets/hiatal-recurrent-redo-2-1200.webp.asset.json";
import image14_1430 from "@/assets/hiatal-recurrent-redo-2-1430.webp.asset.json";

export const HIATAL_RESPONSIVE_IMAGES: Record<string, { srcSet: string; fallback: string }> = {
  [image0_990.url]: {
    srcSet: `${image0_480.url} 480w` + ", " + `${image0_800.url} 800w` + ", " + `${image0_990.url} 990w`,
    fallback: image0_480.url,
  },
  [image1_990.url]: {
    srcSet: `${image1_480.url} 480w` + ", " + `${image1_800.url} 800w` + ", " + `${image1_990.url} 990w`,
    fallback: image1_480.url,
  },
  [image2_1059.url]: {
    srcSet: `${image2_480.url} 480w` + ", " + `${image2_800.url} 800w` + ", " + `${image2_1059.url} 1059w`,
    fallback: image2_480.url,
  },
  [image3_1059.url]: {
    srcSet: `${image3_480.url} 480w` + ", " + `${image3_800.url} 800w` + ", " + `${image3_1059.url} 1059w`,
    fallback: image3_480.url,
  },
  [image4_996.url]: {
    srcSet: `${image4_480.url} 480w` + ", " + `${image4_800.url} 800w` + ", " + `${image4_996.url} 996w`,
    fallback: image4_480.url,
  },
  [image5_996.url]: {
    srcSet: `${image5_480.url} 480w` + ", " + `${image5_800.url} 800w` + ", " + `${image5_996.url} 996w`,
    fallback: image5_480.url,
  },
  [image6_1058.url]: {
    srcSet: `${image6_480.url} 480w` + ", " + `${image6_800.url} 800w` + ", " + `${image6_1058.url} 1058w`,
    fallback: image6_480.url,
  },
  [image7_1058.url]: {
    srcSet: `${image7_480.url} 480w` + ", " + `${image7_800.url} 800w` + ", " + `${image7_1058.url} 1058w`,
    fallback: image7_480.url,
  },
  [image8_790.url]: {
    srcSet: `${image8_480.url} 480w` + ", " + `${image8_790.url} 790w`,
    fallback: image8_480.url,
  },
  [image9_790.url]: {
    srcSet: `${image9_480.url} 480w` + ", " + `${image9_790.url} 790w`,
    fallback: image9_480.url,
  },
  [image10_1448.url]: {
    srcSet: `${image10_480.url} 480w` + ", " + `${image10_800.url} 800w` + ", " + `${image10_1200.url} 1200w` + ", " + `${image10_1448.url} 1448w`,
    fallback: image10_480.url,
  },
  [image11_1448.url]: {
    srcSet: `${image11_480.url} 480w` + ", " + `${image11_800.url} 800w` + ", " + `${image11_1200.url} 1200w` + ", " + `${image11_1448.url} 1448w`,
    fallback: image11_480.url,
  },
  [image12_1456.url]: {
    srcSet: `${image12_480.url} 480w` + ", " + `${image12_800.url} 800w` + ", " + `${image12_1200.url} 1200w` + ", " + `${image12_1456.url} 1456w`,
    fallback: image12_480.url,
  },
  [image13_1456.url]: {
    srcSet: `${image13_480.url} 480w` + ", " + `${image13_800.url} 800w` + ", " + `${image13_1200.url} 1200w` + ", " + `${image13_1456.url} 1456w`,
    fallback: image13_480.url,
  },
  [image14_1430.url]: {
    srcSet: `${image14_480.url} 480w` + ", " + `${image14_800.url} 800w` + ", " + `${image14_1200.url} 1200w` + ", " + `${image14_1430.url} 1430w`,
    fallback: image14_480.url,
  },
};
